/*
 * CRO 05 — de filterknop is er meteen, niet pas na scrollen.
 *
 * Het thema laat de zwevende FILTER-knop pas zien zodra je voorbij de
 * bovenkant van het productgrid scrolt (facets.js zet dan de class `sticky`).
 * Op mobiel zie je daardoor bij het openen van een collectie nergens dat er
 * gefilterd kan worden.
 *
 * We voegen geen tweede knop toe. Dezelfde knop blijft staan; wij zetten er
 * alleen een eigen class op zolang je nog niet voorbij het einde van het grid
 * bent. Daarmee is hij vanaf het laden zichtbaar en verdwijnt hij nog steeds
 * netjes bij de footer — precies de grens die het thema zelf ook aanhoudt.
 */
(function () {
  'use strict';

  var ZICHTBAAR = 'cro-zichtbaar';

  function knop() {
    return document.getElementById('Facets-Toggle-Fixed');
  }

  function pasAan() {
    var k = knop();
    if (!k || k.dataset.croDirect !== 'true') return;

    var grid = document.getElementById('product-grid');
    if (!grid) return;

    // Dezelfde ondergrens als facets.js: zodra het grid voorbij is, weg ermee.
    var einde = grid.offsetTop + grid.offsetHeight - window.innerHeight + 90;
    k.classList.toggle(ZICHTBAAR, window.scrollY < einde);
  }

  function start() {
    pasAan();
    window.addEventListener('scroll', pasAan, { passive: true });
    window.addEventListener('resize', pasAan);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Na het filteren vervangt het thema de inhoud van de knop en herberekent het
  // grid; even opnieuw kijken. Hetzelfde bij een sectiewissel in de editor.
  document.addEventListener('shopify:section:load', pasAan);
  window.setInterval(pasAan, 1500);
})();
